.inputWithCopy {
  display: flex;
  position: relative;

  .input {
    padding: 0;
  }

  .copy {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 35px;
    right: 10px;
    top: 7.5px; // 50% - 35px/2
    border-radius: 50%;
    cursor: pointer;
    @include themify($themes) {
      color: themed("neutral-primary");
      transition: background-color 0.25s ease-in;
      &:hover {
        background-color: themed("neutral-secondary");
      }
    }

    svg {
      width: 17px;
      height: 17px;
    }
  }
}